import { USERS_GROUPS } from "../lib/constants/actions";
export const groups = (state = {}, action) => {
    switch (action.type) {
        case USERS_GROUPS.ADD_GROUPS_SUCCESS:
            return { ...state, groupAdded: action.payload }
        case USERS_GROUPS.LIST_GROUPS_SUCCESS:
            return { ...state, groupsList: action.payload }
        case USERS_GROUPS.GET_GROUPS_ARRAY_SUCCESS:
            return { ...state, groupsArray: action.payload }
        case USERS_GROUPS.ASSIGN_USER_GROUPS_SUCCESS:
            return { ...state, groupAssigned: action.payload }
        default:
            return state;
    }
};




